/**
 * Tutorial guidato delle impostazioni Finance.
 *
 * Un preparativo solo: il riquadro del servizio, che il passo dedicato apre per
 * mostrarne i campi. `stopFinanceTour` lo richiude a fine giro, e solo se ad aprirlo
 * e' stato il tutorial. Gli interruttori non si toccano: salvano subito.
 */
const SCOPE = '[data-tour-scope="setting-finance"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro del primo servizio, se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopFinanceTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createFinanceTourSteps() {
	return [
		{
			body: "Da qui passa la fatturazione: il collegamento con Fatture in Cloud, che trasforma gli ordini in documenti fiscali veri senza doverli riscrivere da un'altra parte.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Il collegamento contabile',
		},
		{
			body: "L'interruttore accende il servizio e salva subito. Acceso senza credenziali valide non emette niente: i documenti restano da fare, e ci si accorge del problema solo quando servono.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Accendere il servizio',
		},
		{
			body: "Il piu' a inizio riga apre la configurazione: clientId e clientSecret arrivano da Fatture in Cloud, dove va registrata l'applicazione. Sono le chiavi che autorizzano il gestionale a emettere documenti a tuo nome.",
			before: stopFinanceTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: "Nel riquadro c'e' anche la parte che vale la pena leggere due volte: i corrispettivi automatici e gli stati ordine che li fanno scattare. Acceso, il gestionale emette il documento da solo quando un ordine entra in quello stato - comodo, ma vuol dire che un cambio di stato sbagliato produce un documento fiscale vero.",
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Credenziali e automatismi',
		},
	];
}
